/**
 * livre-enfant.js — Paris Lovers v5
 * - Streaming SSE pour l'histoire (titre apparaît en ~1s)
 * - 8 pages dans le feuilleteur : couverture, dédicace, 3x (desc illus + texte)
 * - Boutons Commander bloqués tant que previewKey vide
 * - coverKey stocké pour réutilisation dans le PDF final
 */
;(function () {
  'use strict';

  var SUJETS = {
    educatif:  [{v:'alphabet',n:'🔤 Alphabet'},{v:'chiffres',n:'🔢 Chiffres'},{v:'couleurs',n:'🎨 Couleurs'},{v:'animaux',n:'🐾 Animaux'},{v:'nature',n:'🌿 Nature'}],
    conte:     [{v:'licornes',n:'🦄 Licornes'},{v:'princes',n:'👑 Princes & Princesses'},{v:'chevaliers',n:'⚔️ Chevaliers & Dragons'},{v:'sorciers',n:'🧙 École de Sorciers'},{v:'foret',n:'🌲 Forêt Magique'},{v:'sirenes',n:'🧜 Sirènes'},{v:'gnomes',n:'🍄 Gnomes'},{v:'fees',n:'🧚 Fées & Elfes'}],
    aventure:  [{v:'tresor',n:'💎 Trésor caché'},{v:'pirates',n:'🏴‍☠️ Pirates'},{v:'espace',n:'🚀 Espace'},{v:'jungle',n:'🌴 Jungle'},{v:'montagne',n:'⛰️ Montagne'}],
    activites: [{v:'sport',n:'⚽ Sport'},{v:'musique',n:'🎵 Musique'},{v:'cuisine',n:'🍳 Cuisine'},{v:'art',n:'🎨 Art & Dessin'},{v:'danse',n:'💃 Danse'}],
    mondes:    [{v:'sous-marin',n:'🐠 Sous-marin'},{v:'arc-en-ciel',n:'🌈 Arc-en-ciel'},{v:'neige',n:'❄️ Monde des Neiges'},{v:'nuages',n:'☁️ Monde des Nuages'},{v:'miniature',n:'🌸 Monde Miniature'}],
    histoires: [{v:'amitie',n:'🤝 Amitié'},{v:'ecole',n:'🏫 École'},{v:'animaux',n:'🐶 Animaux de compagnie'},{v:'reves',n:'💭 Rêves'},{v:'heros',n:'🌟 Héros ordinaire'}],
    fetes:     [{v:'noel',n:'🎄 Noël'},{v:'anniversaire',n:'🎂 Anniversaire'},{v:'halloween',n:'🎃 Halloween'},{v:'paques',n:'🐣 Pâques'},{v:'eid',n:'🌙 Aïd'}],
    famille:   [{v:'parents',n:'👨‍👩‍👧 Parents'},{v:'grands-parents',n:'👴 Grands-parents'},{v:'freres-soeurs',n:'👫 Frères & Sœurs'},{v:'animaux',n:'🐾 Animal de compagnie'},{v:'bebe',n:'👶 Nouveau bébé'}],
  };

  var S = {
    step: 1, totalSteps: 4,
    age: '', theme: '', sujet: '', message: '',
    style: '', prenom: '', sexe: '', relation: '',
    createur: '', dedicace: '', photoB64: null,
    previewKey: '',
    coverKey:   '',
    childDescription: '',
  };

  function capitalize(s) {
    if (!s) return s;
    return s.toLowerCase().charAt(0).toUpperCase() + s.toLowerCase().slice(1);
  }

  window.lp = {
    pick: pick, pickChip: pickChip, updateSujets: updateSujets,
    photo: photo, next: next, back: back, check: check,
    preview: preview, cover: cover, cart: cart,
    flipPage: function(d) { var np = currentPage + d; if (np >= 0 && np < totalPages) goPage(np); },
    goPage: function(i) { goPage(i); },
    goSection: goSection,
    gallery: function(idx) { gallery(idx); },
  };

  var AGE_LABELS = { '0-2':'0 à 2 ans', '3-5':'3 à 5 ans', '6-9':'6 à 9 ans', '10+':'10+ ans' };
  var THEME_LABELS_SHORT = { educatif:'Éducatif', conte:'Conte', aventure:'Aventure', activites:'Activités', mondes:'Mondes', histoires:'Histoires', fetes:'Fêtes', famille:'Famille' };
  var MESSAGE_LABELS = { amitie:'Amitié', courage:'Courage', nature:'Nature', amour:'Amour', perseverance:'Persévérance', partage:'Partage', honnetete:'Honnêteté', respect:'Respect' };

  function next() {
    if (!validateStep(S.step)) return;
    collectStep(S.step);
    updateAccordionSection(S.step, true);
    if (S.step < S.totalSteps) { S.step++; openAccordionSection(S.step); }
  }
  function back() { if (S.step > 1) S.step--; }

  function openAccordionSection(num) {
    var body   = document.getElementById('lp-acc-b' + num);
    var header = document.getElementById('lp-acc-h' + num);
    if (body)   body.classList.add('open');
    if (header) { header.classList.remove('done'); header.classList.add('active'); }
    for (var i = 1; i <= S.totalSteps; i++) {
      var bar = document.getElementById('ps' + i);
      if (bar) { bar.classList.toggle('active', i === num); bar.classList.toggle('done', i < num); }
    }
    if (body) setTimeout(function() { body.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
  }

  function updateAccordionSection(num, done) {
    var header = document.getElementById('lp-acc-h' + num);
    var sum    = document.getElementById('lp-sum-' + num);
    if (!header) return;
    if (done) { header.classList.remove('active'); header.classList.add('done'); }
    if (sum) {
      if (num === 1) sum.textContent = AGE_LABELS[S.age] || S.age;
      if (num === 2) sum.textContent = (THEME_LABELS_SHORT[S.theme] || '') + (S.message ? ' · ' + (MESSAGE_LABELS[S.message] || S.message) : '');
      if (num === 3) sum.textContent = S.prenom || '';
      if (num === 4) sum.textContent = S.dedicace ? '✓' : '';
    }
  }

  function goSection(num) {
    if (num >= S.step) return;
    var body   = document.getElementById('lp-acc-b' + num);
    var header = document.getElementById('lp-acc-h' + num);
    if (!body) return;
    var isOpen = body.classList.contains('open');
    body.classList.toggle('open', !isOpen);
    if (header) header.classList.toggle('active', !isOpen);
  }

  function validateStep(step) {
    if (step === 1 && !S.age)          { flashGroup('lp-ages');     return false; }
    if (step === 2 && !S.theme)        { flashGroup('lp-themes');   return false; }
    if (step === 2 && !S.message)      { flashGroup('lp-messages'); return false; }
    if (step === 3 && !S.prenom.trim()) { shakeField('lp-prenom');  return false; }
    return true;
  }

  function collectStep(step) {
    if (step === 3) { S.prenom = (val('lp-prenom') || '').trim(); if (!S.sexe) S.sexe = 'neutre'; }
    if (step === 4) { S.createur = val('lp-createur') || ''; S.dedicace = val('lp-dedicace') || ''; }
  }

  function val(id) { var el = document.getElementById(id); return el ? el.value : ''; }
  function check() { S.prenom = (val('lp-prenom') || '').trim(); }

  function pick(field, el) {
    el.parentElement.querySelectorAll('.lp-tile').forEach(function(t) { t.classList.remove('on'); });
    el.classList.add('on');
    S[field] = el.dataset.v;
  }

  function pickChip(field, el) {
    el.parentElement.querySelectorAll('.lp-chip').forEach(function(c) { c.classList.remove('on'); });
    el.classList.add('on');
    S[field] = el.dataset.v;
    if (field === 'relation') {
      var v = el.dataset.v;
      if (v === 'fille' || v === 'petite-fille' || v === 'niece') S.sexe = 'fille';
      else if (v === 'fils' || v === 'petit-fils' || v === 'neveu') S.sexe = 'garcon';
      else S.sexe = 'neutre';
    }
  }

  function updateSujets() {
    var wrap    = document.getElementById('lp-sujets-wrap');
    var grid    = document.getElementById('lp-sujets');
    var options = SUJETS[S.theme] || [];
    if (!wrap || !grid) return;
    if (!options.length) { wrap.style.display = 'none'; return; }
    wrap.style.display = 'block';
    grid.innerHTML = '';
    S.sujet = '';
    options.forEach(function(opt) {
      var parts = opt.n.split(' ');
      var icon  = parts[0];
      var name  = parts.slice(1).join(' ') || opt.n;
      var div   = document.createElement('div');
      div.className = 'lp-tile';
      div.dataset.v = opt.v;
      div.innerHTML = '<span class="lp-tile-icon">' + icon + '</span><span class="lp-tile-name">' + name + '</span>';
      div.onclick   = function() { pick('sujet', this); };
      grid.appendChild(div);
    });
  }

  function photo(input) {
    if (!input.files || !input.files[0]) return;
    if (input.files[0].size > 8 * 1024 * 1024) { alert('Photo trop volumineuse (max 8 Mo).'); return; }
    var reader = new FileReader();
    reader.onload = function(e) {
      S.photoB64 = e.target.result;
      var prev = document.getElementById('lp-photo-prev');
      if (prev) { prev.src = e.target.result; prev.style.display = 'block'; }
      var icon = document.getElementById('lp-upload-icon'); if (icon) icon.style.display = 'none';
      var txt  = document.getElementById('lp-upload-txt');
      if (txt) txt.innerHTML = '✅ Photo prête — couverture ressemblante activée<br><small style="color:#2d6a3f">Visage détecté · Meilleur résultat garanti</small>';
    };
    reader.readAsDataURL(input.files[0]);
  }

  function preview() {
    collectStep(4);
    if (!S.age || !S.theme || !S.message || !S.prenom) return;
    S.prenom = capitalize(S.prenom);
    if (!S.style) {
      var pool = { educatif:['watercolor','gouache'], conte:['watercolor','anime','storybook'], aventure:['3d','comic'], activites:['3d','kawaii'], mondes:['anime','watercolor'], histoires:['watercolor','storybook'], fetes:['3d','kawaii'], famille:['watercolor','storybook'] };
      var arr = pool[S.theme] || ['watercolor'];
      S.style = arr[Math.floor(Math.random() * arr.length)];
    }
    S.previewKey = '';
    S.coverKey   = '';
    S.childDescription = '';
    updateCartButtons();

    var nameEl = document.getElementById('lp-prev-name');
    if (nameEl) nameEl.textContent = S.prenom;
    var sec = document.getElementById('lp-preview-section');
    sec.classList.add('visible');
    setTimeout(function() { sec.scrollIntoView({ behavior:'smooth', block:'start' }); }, 50);

    populateFlipbook();
    goPage(0);
    cover();
  }

  // ── COUVERTURE ──
  function cover() {
    var gen     = document.getElementById('lp-cover-gen');
    var img     = document.getElementById('lp-cover-img');
    var overlay = document.getElementById('lp-cover-overlay');
    var err     = document.getElementById('lp-cover-err');
    var regen   = document.getElementById('lp-regen');

    if (gen)     gen.style.display     = 'flex';
    if (img)     { img.style.display   = 'none'; img.src = ''; }
    if (overlay) overlay.style.display = 'none';
    if (err)     err.style.display     = 'none';
    if (regen)   regen.style.display   = 'none';

    var workerUrl = window.LP_WORKER_URL || '';
    if (!workerUrl) { if (gen) gen.style.display = 'none'; if (err) err.style.display = 'block'; return; }

    fetch(workerUrl + '/api/cover', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ prenom:S.prenom, theme:S.theme, sujet:S.sujet, style:S.style, sexe:S.sexe, age:S.age, photoB64:S.photoB64||null }),
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.error || !data.url) {
        if (gen) gen.style.display = 'none';
        if (err) { err.style.display = 'block'; err.innerHTML = (data.error||'Erreur') + ' <a href="#" onclick="lp.cover();return false">Réessayer</a>'; }
        return;
      }
      if (data.coverKey) S.coverKey = data.coverKey;
      if (data.description) S.childDescription = data.description;
      if (!img) return;
      img.onload = function() {
        if (gen) gen.style.display = 'none';
        img.style.display = 'block';
        var coverTitleEl = document.getElementById('lp-cover-title');
        var titleBookEl  = document.getElementById('lp-title-book-title');
        var realTitle = (titleBookEl && titleBookEl.textContent && !titleBookEl.textContent.endsWith('…') && titleBookEl.textContent !== 'Génération en cours…') ? titleBookEl.textContent : '';
        if (coverTitleEl && realTitle) coverTitleEl.textContent = realTitle;
        if (overlay) overlay.style.display = 'flex';
        if (regen)   regen.style.display   = 'block';
        updateCartButtons();
      };
      img.onerror = function() { if (gen) gen.style.display = 'none'; if (err) err.style.display = 'block'; };
      img.src = data.url;
    })
    .catch(function() { if (gen) gen.style.display = 'none'; if (err) err.style.display = 'block'; });
  }

  // ── FEUILLETEUR — 10 pages ──
  // P1: Couverture | P2: Dédicace | P3: Illus 1 | P4: Histoire 1 | P5: Illus 2 | P6: Histoire 2 | P7: Illus 3 | P8: Histoire 3 | P9: Illus 4 | P10: Cadenas
  var currentPage = 0;
  var totalPages  = 10;
  var PAGE_LABELS = ['Couverture', 'Dédicace', 'Illustration 1', 'Page 1', 'Illustration 2', 'Page 2', 'Illustration 3', 'Page 3', 'Illustration 4', 'Suite…'];

  function goPage(idx) {
    if (idx < 0 || idx >= totalPages) return;
    for (var i = 1; i <= totalPages; i++) {
      var pg = document.getElementById('lp-pg-' + i);
      if (pg) pg.classList.remove('active');
    }
    var t = document.getElementById('lp-pg-' + (idx+1));
    if (t) t.classList.add('active');
    currentPage = idx;
    document.querySelectorAll('.lp-book-dot').forEach(function(d,i){ d.classList.toggle('active', i===idx); });
    var lbl = document.getElementById('lp-nav-label');
    if (lbl) lbl.textContent = PAGE_LABELS[idx] || '';
    var prev = document.getElementById('lp-nav-prev'), nxt = document.getElementById('lp-nav-next');
    if (prev) prev.disabled = idx === 0;
    if (nxt)  nxt.disabled  = idx === totalPages-1;
  }

  (function() {
    var c = document.getElementById('lp-pages-container');
    if (!c) return;
    var sx = 0;
    c.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
    c.addEventListener('touchend',   function(e){ var d = sx - e.changedTouches[0].clientX; if(Math.abs(d)>40) window.lp.flipPage(d>0?1:-1); }, {passive:true});
  })();

  function setTitle(title) {
    ['lp-title-book-title','lp-story-title','lp-cover-title'].forEach(function(id){
      var el = document.getElementById(id); if(el) el.textContent = title;
    });
  }

  function setPageText(pageIndex, text) {
    var domIds = ['lp-pg-4-text', 'lp-pg-6-text', 'lp-pg-8-text'];
    if (pageIndex < 0 || pageIndex >= domIds.length) return;
    var el = document.getElementById(domIds[pageIndex]);
    if (el) {
      el.textContent = text;
      el.style.textAlign  = 'center';
      el.style.display    = 'flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
    }
  }

  function setSceneDesc(sceneIndex, desc) {
    var domIds = ['lp-pg-3', 'lp-pg-5', 'lp-pg-7'];
    if (sceneIndex < 0 || sceneIndex >= domIds.length) return;
    var el = document.getElementById(domIds[sceneIndex]);
    if (!el) return;
    el.innerHTML = [
      '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;padding:28px;text-align:center;background:#FDFAF6;gap:14px">',
      '<div style="font-size:32px;opacity:0.35">🎨</div>',
      '<div style="font-family:Georgia,serif;font-size:13px;font-style:italic;color:#555;line-height:1.9;max-width:220px">' + desc + '</div>',
      '<div style="font-size:9px;color:#bbb;letter-spacing:0.1em;text-transform:uppercase;margin-top:4px">Illustration pleine page dans votre livre</div>',
      '</div>',
    ].join('');
  }

  // ── APERÇU HISTOIRE ──
  function populateFlipbook() {
    // Remplir la dédicace (P2)
    var ded = document.getElementById('lp-title-dedicace');
    if (ded) ded.textContent = 'Pour ' + S.prenom + (S.dedicace ? ', ' + S.dedicace : ', cette histoire a été créée rien que pour toi.');
    var createurEl = document.getElementById('lp-title-createur');
    if (createurEl) createurEl.textContent = S.createur ? '— ' + S.createur + ' —' : '';
    var lockEl = document.getElementById('lp-lock-prenom');
    if (lockEl) lockEl.textContent = S.prenom;

    // Placeholders texte (P4, P6, P8)
    ['lp-pg-4-text','lp-pg-6-text','lp-pg-8-text'].forEach(function(id){
      var el = document.getElementById(id);
      if (el) el.innerHTML = '<span style="color:#ccc;font-style:italic;font-size:12px">Génération en cours…</span>';
    });

    setTitle('Génération en cours…');
    showProgress();

    var workerUrl = window.LP_WORKER_URL || '';
    if (!workerUrl) { setTitle(S.prenom + ' et son aventure'); hideProgress(); return; }

    fetch(workerUrl + '/api/story', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        prenom:   S.prenom,   age:      S.age,
        theme:    S.theme,    sujet:    S.sujet    || '',
        message:  S.message  || '',   sexe: S.sexe || 'neutre',
        style:    S.style    || 'watercolor',
        dedicace: S.dedicace || '',   createur: S.createur || '',
      }),
    })
    .then(function(r) { 
      if (!r.ok) throw new Error('Erreur serveur');
      return r.json(); 
    })
    .then(function(data) {
      hideProgress();
      
      if (!data || !data.story) { 
        console.error('Réponse invalide:', data);
        setTitle(S.prenom + ' et son aventure'); 
        return; 
      }

      // Stocker previewKey
      if (data.previewKey) { 
        S.previewKey = data.previewKey; 
        updateCartButtons(); 
      }

      // Titre
      var titre = data.story.titre || (S.prenom + ' et son aventure');
      setTitle(titre);
      var coverTitleEl = document.getElementById('lp-cover-title');
      if (coverTitleEl) coverTitleEl.textContent = titre;

      // Pages histoire (P4 = pages[0], P6 = pages[1], P8 = pages[2])
      var pages = data.story.pages || [];
      var pg4 = document.getElementById('lp-pg-4-text');
      var pg6 = document.getElementById('lp-pg-6-text');
      var pg8 = document.getElementById('lp-pg-8-text');
      if (pg4 && pages[0]) { pg4.textContent = pages[0]; }
      if (pg6 && pages[1]) { pg6.textContent = pages[1]; }
      if (pg8 && pages[2]) { pg8.textContent = pages[2]; }
    })
    .catch(function(err) {
      console.error('Erreur populateFlipbook:', err);
      hideProgress();
      setTitle(S.prenom + ' et son aventure');
    });
  }

  function showProgress() {
    var wrap = document.getElementById('lp-progress-wrap');
    if (wrap) wrap.style.display = 'block';
    var bar = document.getElementById('lp-progress-bar');
    if (bar) { bar.style.display = 'block'; bar.style.width = '0%'; }
    var pct = 0;
    var interval = setInterval(function() {
      pct += (100 - pct) * 0.04; // courbe exponentielle qui approche 95%
      if (pct > 95) pct = 95;
      if (bar) bar.style.width = pct + '%';
    }, 300);
    window._progressInterval = interval;
  }

  function hideProgress() {
    if (window._progressInterval) clearInterval(window._progressInterval);
    var bar = document.getElementById('lp-progress-bar');
    if (bar) { bar.style.width = '100%'; setTimeout(function(){
      bar.style.display = 'none';
      var wrap = document.getElementById('lp-progress-wrap');
      if (wrap) wrap.style.display = 'none';
    }, 400); }
  }

    // ── Activer/désactiver les boutons Commander ──
  function updateCartButtons() {
    var ready = S.previewKey && S.previewKey.length > 0;
    document.querySelectorAll('.lp-btn-buy, .lp-btn-pco, .lp-btn-pcf, .lp-preview-cta-btn, .lp-lock-btn, .lp-sticky-btn').forEach(function(btn) {
      btn.disabled      = !ready;
      btn.style.opacity = ready ? '1' : '0.5';
      btn.title         = ready ? '' : 'Génération de votre histoire en cours…';
    });
  }

  // ── PANIER ──
  async function getVariantId(type) {
    var variants = window.LP_VARIANTS || {};
    var id = variants[type];
    if (id && id !== 0) return id;
    try {
      var res     = await fetch(window.location.pathname.replace(/\/$/, '') + '.js');
      var product = await res.json();
      var variant = (product.variants || []).find(function(v) {
        var t = (v.title || '').toLowerCase();
        if (type === 'relie') return t.includes('reli');
        if (type === 'pack')  return t.includes('pack');
        return t.includes('book') || t.includes('ebook');
      });
      if (variant && variant.id) return variant.id;
    } catch(e) {}
    return 0;
  }

  async function cart(type) {
    if (!S.prenom) { alert("Merci d'entrer le prénom de l'enfant."); return; }
    if (!S.previewKey) { alert('Votre histoire est encore en cours de génération, merci de patienter quelques secondes.'); return; }

    var btn  = document.activeElement;
    var orig = btn && btn.tagName === 'BUTTON' ? btn.textContent : '';
    if (btn && btn.tagName === 'BUTTON') { btn.disabled = true; btn.textContent = 'Ajout en cours…'; }

    var variantId = await getVariantId(type);
    if (!variantId || variantId === 0) {
      if (btn && btn.tagName === 'BUTTON') { btn.disabled = false; btn.textContent = orig; }
      window.location.href = window.location.pathname;
      return;
    }

    var properties = {
      'Prenom':             S.prenom,
      'Tranche d age':      S.age,
      'Theme':              S.theme,
      'Sujet':              S.sujet      || '',
      'Message':            S.message    || '',
      'Style illustration': S.style      || '',
      'Relation':           S.relation   || '',
      'Createur':           S.createur   || '',
      'Dedicace':           S.dedicace   || '',
    };
    if (S.previewKey) properties['Preview Key'] = S.previewKey;
    if (S.coverKey)   properties['Cover Key']   = S.coverKey;
    if (S.childDescription) properties['Child Description'] = S.childDescription;
    if (S.photoB64)   properties['Photo']       = 'Oui';

    // Fix Safari mobile: form submit natif contourne le cache inventory
    var existingForm = document.getElementById('lp-cart-form-hidden');
    if (existingForm) existingForm.remove();

    var form = document.createElement('form');
    form.id = 'lp-cart-form-hidden';
    form.method = 'POST';
    form.action = '/cart/add';
    form.style.cssText = 'position:absolute;left:-9999px;';

    var addInput = function(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };

    addInput('id', variantId);
    addInput('quantity', '1');
    addInput('return_to', '/cart');

    Object.keys(properties).forEach(function(key) {
      addInput('properties[' + key + ']', properties[key]);
    });

    document.body.appendChild(form);
    form.submit();
  }

  function shakeField(id) {
    var el = document.getElementById(id); if (!el) return;
    el.style.borderColor = 'var(--pl-rose)'; el.focus();
    setTimeout(function(){ el.style.borderColor = ''; }, 1000);
  }

  function flashGroup(id) {
    var el = document.getElementById(id); if (!el) return;
    el.style.outline = '2px solid var(--pl-rose)'; el.style.borderRadius = '6px';
    el.scrollIntoView({ behavior:'smooth', block:'center' });
    setTimeout(function(){ el.style.outline = ''; el.style.borderRadius = ''; }, 1500);
  }

  var galleryImages = [];
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.lp-gallery-thumb img').forEach(function(img){
      galleryImages.push(img.src.replace('width=300','width=800'));
    });
  });
  function gallery(idx) {
    var m = document.getElementById('lp-main-img');
    if (m && galleryImages[idx]) m.src = galleryImages[idx];
    document.querySelectorAll('.lp-gallery-thumb').forEach(function(t,i){ t.classList.toggle('active', i===idx); });
  }

  var sticky = document.getElementById('lp-sticky');
  if (sticky) window.addEventListener('scroll', function(){ sticky.style.display = window.scrollY>500?'block':'none'; }, {passive:true});

})();
